import React from 'react'
import HomeVerticalSmallMobile from './HomeVerticalSmallMobile'

const Home = () => {
  return (
    <div className="home">
      <HomeVerticalSmallMobile />
    </div>
  )
}

export default Home




// WEBPACK FOOTER //
// ./src/Home.js